import store from "@packages/store";
import Vue from "vue";

export default {
    async listToFilter({ pagination, filters }) {
        const listToFilter = await Vue.api.advertising.listToFilter({
            pagination,
            filters
        });
        store.commit("ADVERTISING_SET_LIST_FILTER", listToFilter);
        return listToFilter;
    },

    async list({ pagination, filters }) {
        const list = await Vue.api.advertising.list({ pagination, filters });
        store.commit("ADVERTISING_SET_LIST", list);
        return list;
    },

    async count({ filters }) {
        const count = await Vue.api.advertising.count({ filters });
        store.commit("ADVERTISING_SET_COUNT", count);
        return count;
    },

    async find(id) {
        const advertising = await Vue.api.advertising.find(id);
        store.commit("SET_SINGLE_ADVERTISING", advertising);
        return advertising;
    },

    async devicesList(id) {
        let list = await Vue.api.advertising.devicesList(id);
        store.commit("SET_ADVERTISING_DEVICES", list);
        return list;
    }
};
